const FooterBottomShape01 = () => {

    return (<div className="rmdr-footer-bottom-shape-01" />)

}

export default FooterBottomShape01;
